module.exports = __webpack_public_path__ + "static/ja-b0711804f78de1b72a4765d3ab0f2238.jpg";